import Teacher from './Teacher'

export default class ClassroomTeacher extends Teacher {

  documentNumber!: string
  email!: string
  updatedAt!: Date

}